/**
 * Node tool «Связь»: квадрат с закруглёнными краями и иконкой relation-multi, повёрнутой на 90°.
 * По клику — событие connection:selectType (выбор типа связи), затем пользователь тянет к целевому узлу.
 */
const RELATION_MULTI_PATH =
	'M916 798l-410-109 64-95-486-327 25-38 486 328 62-92 259 333 0 0z m0-328l-411-109 151-224 260 333 0 0z m-409-245l-63-43 25-37 63 42-25 38z m-126-85l-62-42 25-38 62 43-25 37z m-133-90l-63-43 25-37 63 43-25 37z m-126-85l-38-26 25-37 38 26-25 37z';

const SIZE = 20;
const RADIUS = 4;

export default {
	inherit: 'button',
	x: '100%',
	y: '100%',
	offset: {x: 15, y: -15},
	markup: [
		{
			tagName: 'rect',
			selector: 'button',
			attrs: {
				x: -SIZE / 2,
				y: -SIZE / 2,
				width: SIZE,
				height: SIZE,
				rx: RADIUS,
				ry: RADIUS,
				fill: 'rgba(128, 128, 128, 0.5)',
				stroke: '#fff',
				'stroke-width': 1.5,
				cursor: 'pointer',
			},
		},
		{
			tagName: 'path',
			selector: 'icon',
			attrs: {
				d: RELATION_MULTI_PATH,
				fill: '#000',
				'pointer-events': 'none',
				transform: 'rotate(-90) scale(0.018) translate(-500,-350)',
			},
		},
	],
	onClick: ({view, cell, e}) => {
		if (!view?.graph || !cell?.id) return;
		const ev = e?.e ?? e;
		view.graph.trigger('connection:selectType', {
			nodeId: cell.id,
			clientX: ev?.clientX ?? 0,
			clientY: ev?.clientY ?? 0,
		});
	},
};
